'use es6';

import useSettledUrl from '../../hooks/useSettledUrl';
import { getAchievementUrlSlug } from '../../utils/urls';
import { usePublicAchievement, useAchievementTrackId, useTrackPublicData, TrackingProvider, SingleAchievement } from '../../features/achievement';
import { useRouteMatch } from 'quartz-routing/react-router';
import { toAwardType } from '../../utils/awardTrackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const PublicAchievementContainer = () => {
  const match = useRouteMatch('/:publicId/:language/:template/:slug+');
  const {
    language,
    publicId,
    slug
  } = match.params;
  const {
    publicAchievement,
    publicAchievementUser
  } = usePublicAchievement(publicId);
  const trackId = useAchievementTrackId(publicId);
  const {
    track: trackPublicData
  } = useTrackPublicData(trackId);
  const trackName = trackPublicData === null || trackPublicData === void 0 ? void 0 : trackPublicData.name;
  const urlSlug = publicAchievementUser && trackName ? getAchievementUrlSlug({
    firstName: publicAchievementUser.firstName,
    lastName: publicAchievementUser.lastName,
    trackName
  }) : undefined;
  useSettledUrl({
    actualSlug: slug,
    urlSlug
  });
  const type = toAwardType(publicAchievement === null || publicAchievement === void 0 ? void 0 : publicAchievement.credentialType);
  return /*#__PURE__*/_jsx(TrackingProvider, {
    enabled: !!publicAchievement,
    language: language,
    publicId: publicId,
    type: type,
    children: /*#__PURE__*/_jsx(SingleAchievement, {
      language: language,
      publicId: publicId
    })
  });
};
export default PublicAchievementContainer;